// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop_backToTop__3ITes","show":"BackToTop_show__16LPu"};